<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO: {{ formData.evgExpenseNo || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.evgExpenseStatus === 'Y'
              ? 'success'
              : formData.evgExpenseStatus === 'S'
              ? 'warning'
              : formData.evgExpenseStatus === 'D' ||
                formData.evgExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_evgExpenseStatus || 'New' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.salesPersonName"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDateEndOpt"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="'OA申请方式'" prop="oaExpenseProcess">
            <dict-select
              v-model="formData.oaExpenseProcess"
              url="/master/common/dict/biz"
              :body="{ dictType: 'oaExpenseProcess' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
              @change="oaExpenseProcessChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'付款公司'" prop="expensePayerCode">
            <dict-select
              v-model="formData.expensePayerCode"
              url="/master/common/dict/biz"
              :body="expensePayerParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              :selectedLabel.sync="formData.expensePayerName"
              filterable
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_payeeType') || '收款方'"
            prop="payeeType"
          >
            <dict-select
              v-model="formData.payeeType"
              url="/master/common/dict/biz"
              :body="payeeTypeParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
              @change="payeeTypeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.payeeType === 'S'">
          <el-form-item
            :label="$l('form_label_payeeScmCode') || '收款供应商'"
            prop="payeeScmCode"
          >
            <dict-select
              v-model="formData.payeeScmCode"
              url="/master/common/dict/allScmCooperated"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
              @change="payeeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.payeeType === 'C'">
          <el-form-item
            :label="$l('form_label_payeeCustCode') || '收款客户'"
            prop="payeeCustCode"
          >
            <dict-select
              v-model="formData.payeeCustCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
              @change="payeeChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="!oaExpenseProcessIsA">
          <el-form-item
            :label="$l('form_label_costCategory') || '费用大类'"
            prop="costCategory"
          >
            <dict-select
              v-model="formData.costCategory"
              url="/master/common/dict/biz"
              :body="costCategoryParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="oaExpenseProcessIsA">
          <el-form-item
            :label="$l('INDEX.form_label_payeeScmBankName') || '收款方开户银行'"
            prop="bankName"
          >
            <el-input
              v-model="formData.bankName"
              readonly
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePayScmBank"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="oaExpenseProcessIsA">
          <el-form-item
            :label="$l('form_label_evgRequestType') || '请款类型'"
            prop="evgRequestType"
          >
            <dict-select
              v-model="formData.evgRequestType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'evgRequestType' }"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="oaExpenseProcessIsA">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountName') || '收款方账户名称'
            "
          >
            <el-input v-model="formData.bankAccountName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountNo') || '收款方银行账号'
            "
          >
            <el-input v-model="formData.bankAccountNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountType') ||
                '收款方银行账户性质'
            "
          >
            <el-input v-model="formData.v_bankAccountType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_payeeScmBankAccountKind') ||
                '收款方银行账号类别'
            "
          >
            <el-input v-model="formData.v_bankAccountKind" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="!oaExpenseProcessIsA">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_substituteInvoice') || '代用发票'"
          >
            <el-select
              v-model="formData.substituteInvoice"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_forwardGeneralManager') || '转送总经理'"
          >
            <el-select
              v-model="formData.forwardGeneralManager"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_businessConsumption') || '业务消费'"
          >
            <el-select
              v-model="formData.businessConsumption"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_otherSet') || '420'">
            <el-select
              v-model="formData.otherSet"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '付款用途'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_description') || '情况说明'">
            <el-input
              v-model="formData.description"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="'备注'">
            <el-input
              v-model="formData.notes"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :evgExpenseCode="evgExpenseCode"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          :depCode="salesPersonInfo.depCode"
          :orgDepFullName="salesPersonInfo.orgDepFullName"
          :substituteInvoice="formData.substituteInvoice"
          :oaExpenseProcess="formData.oaExpenseProcess"
          :showSubstituteInvoice="oaExpenseProcessIsA"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :evgExpenseCode="evgExpenseCode"
        />
      </el-row>
    </el-form>
    <ChooseBank
      :visible.sync="chooseScmBankVisible"
      :title="$l('dialog_title_choose_payeeScmBank') || '选择收款方银行信息'"
      @confirm="updateBanInfo"
      :selectApi="selectBankApi"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import ChooseBank from '../choose-bank'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable, ChooseBank },
  mixins: [EditLoading],
  props: {
    evgExpenseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      chooseScmBankVisible: false,
      expensePayerParams: { dictType: 'expensePayer' },
      payeeTypeParams: { dictType: 'payeeType' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      costCategoryParams: { dictType: 'costCategory' },
      selectBankApi: () => [],
      selectOptions: [
        { label: this.$l('INDEX.YES') || '是', value: '0' },
        { label: this.$l('INDEX.NO') || '否', value: '1' },
      ],
      requestDateEndOpt: this.requestDateEnd(),
      formData: {
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
        salesPersonCode: '',
        salesPersonName: '',
        payeeType: 'C',
        oaExpenseProcess: 'A',
        payeeScmCode: '',
        payeeCustCode: '',
        currencyAmount: 0,
        cashAdvances: 0,
        remark: '',
        description: '',
        substituteInvoice: '1',
        forwardGeneralManager: '1',
        businessConsumption: '1',
        otherSet: '1',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        bankAccountType: '',
        v_bankAccountType: '',
        bankAccountKind: '',
        v_bankAccountKind: '',
      },
      salesPersonInfo: {},
    }
  },
  computed: {
    rules() {
      return {
        oaExpenseProcess: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        paymentMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        costCategory: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeCustCode: [
          {
            required: this.formData.payeeType === 'C',
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeScmCode: [
          {
            required: this.formData.payeeType === 'S',
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        bankName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      }
    },
    oaExpenseProcessIsA() {
      return this.formData.oaExpenseProcess == 'A'
    },
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.evgExpenseCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    // 查询业务人员详情，主要取部门信息作为费用明细的默认分摊部门
    'formData.salesPersonCode': {
      async handler(userCode) {
        if (!userCode) return

        const res = await this.$api.sysUserDetailApi({ userCode })
        if (!res) return
        this.salesPersonInfo = res.body || {}
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    // 申请日期限制
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.evgExpenseCode) return
      this.$api
        .ecomEvgExpenseDetailApi({
          evgExpenseCode: this.evgExpenseCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      console.log(result)
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || !listItem.length) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }
      for (let i = 0; i < listItem.length; i++) {
        if (
          listItem[i].substituteInvoice === '0' &&
          !listItem[i].originalExpenseType
        ) {
          this.$message.error(
            this.$l('tips_add_original_cost') || '请添加原始费用项目'
          )
          return
        }
      }
      const listDoc = this.$refs.docTable.getTableData() || []
      this.loadingOpen()
      this.$api
        .ecomEvgExpenseSaveApi({ ...this.formData, listItem, listDoc })
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.evgExpenseCode) {
            this.closeCurPage()
          } else {
            this.reload()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async getCustData(form) {
      return await this.$api
        .masterCustomerBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    async getScmData(form) {
      return await this.$api
        .masterScmInfoBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    async payeeChange(code) {
      const { payeeType } = this.formData
      const listBank =
        payeeType == 'C'
          ? await this.getCustData({ custCode: code })
          : await this.getScmData({ scmCode: code })
      const bankData = !listBank || listBank.length > 1 ? {} : listBank[0] || {}
      this.updateBanInfo(bankData)
    },
    payeeTypeChange() {
      this.formData.payeeScmCode = ''
      this.formData.payeeCustCode = ''
      this.updateBanInfo({})
    },
    oaExpenseProcessChange() {
      if (this.formData.oaExpenseProcess !== 'B') {
        this.formData.substituteInvoice = '1'
      }
    },
    openChoosePayScmBank() {
      const { payeeScmCode, payeeCustCode } = this.formData
      if (!payeeScmCode && !payeeCustCode) {
        this.$message({
          message: '请先选择收款客户或收款供应商',
          type: 'warning',
        })
        return
      }

      const { payeeType } = this.formData
      if (payeeType === 'C') {
        this.selectBankApi = (form) =>
          this.getCustData({ ...form, custCode: this.formData.payeeCustCode })
      } else {
        this.selectBankApi = (form) =>
          this.getScmData({ ...form, scmCode: this.formData.payeeScmCode })
      }

      this.chooseScmBankVisible = true
    },
    updateBanInfo(e) {
      const {
        bankName = '',
        bankAccountName = '',
        bankAccountNo = '',
        bankAccountType = '',
        v_bankAccountType = '',
        bankAccountKind = '',
        v_bankAccountKind = '',
      } = e || {}
      this.formData.bankName = bankName
      this.formData.bankAccountName = bankAccountName
      this.formData.bankAccountNo = bankAccountNo
      this.formData.bankAccountType = bankAccountType
      this.formData.v_bankAccountType = v_bankAccountType
      this.formData.bankAccountKind = bankAccountKind
      this.formData.v_bankAccountKind = v_bankAccountKind
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
